import cn from 'classnames'
import { isEmpty } from 'lodash'

type TProps = {
  name: string
  onChange: (val: string) => void
  value: string
  label?: string
  error?: string
  className?: string
  maxLength?: number
  readonly?: boolean
  required?: boolean
  showValidationErrors?: boolean
  textarea?: boolean
  type?: string
  wrapperClassName?: string
  masked?: boolean
  disabled?: boolean
  field?: { name: string }
}

const TextBox = (props: TProps) => {
  const {
    className,
    name,
    onChange,
    value,
    label,
    error = null,
    maxLength = null,
    readonly = false,
    required = false,
    showValidationErrors = false,
    textarea = false,
    wrapperClassName,
    masked = false,
    disabled,
    field,
  } = props

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(event.target.value)
  }

  let textInput = (
    <>
      <input
        className={cn('textbox__input', className)}
        maxLength={maxLength as number}
        name={name ?? field?.name}
        readOnly={readonly}
        required={required}
        type="text"
        value={value}
        onFocus={(e) => (!masked ? (e.target.value = '') : null)}
        placeholder="#"
        onChange={onChangeInput}
      />
    </>
  )
  if (label) {
    textInput = (
      <div
        className={cn('textbox', wrapperClassName, {
          '-error': showValidationErrors && !isEmpty(error),
          '-disabled': disabled,
        })}
      >
        <input
          className={cn('textbox__input', className, { '-disabled': disabled })}
          maxLength={maxLength as number}
          name={name ?? field?.name}
          onChange={onChangeInput}
          readOnly={readonly}
          required={required}
          type="text"
          value={value}
          onFocus={(e) => (masked ? (e.target.value = '') : null)}
          disabled={disabled}
          placeholder="#"
          id={name}
        />
        <label className={cn('textbox__label', { '-disabled': disabled })} htmlFor={name}>
          {label}
        </label>
      </div>
    )
  }

  if (textarea) {
    textInput = (
      <>
        <textarea
          className={cn('textbox__input', '-textarea', className)}
          name={name ?? field?.name}
          onChange={onChangeInput}
          readOnly={readonly}
          rows={4}
          value={value}
          id={name}
        />
        <label className="textbox__label" htmlFor={name}>
          {label}
        </label>
      </>
    )
  }

  return textInput
}

export default TextBox
